/**
 * Copyright 2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
import { labels } from '@umati/dashboard-common';
import SectionData from 'components/machine/sectionData';

export interface ISurfaceMetaProps {
  Location?: string;
  Name?: string;
  SerialNumber?: string;
  Volume?: string;
}

export default function SurfaceMeta(props: ISurfaceMetaProps) {
  const colStyle = 'col-12 col-sm-6 col-md-4';
  return (
    <div className="section">
      <div className="row">
        {props.Location !== undefined && <SectionData cols={colStyle} label={labels.location} value={props.Location} />}
        {props.Name !== undefined && <SectionData cols={colStyle} label={labels.name} value={props.Name} />}
        {props.SerialNumber !== undefined && (
          <SectionData cols={colStyle} label={labels.serialNumber} value={props.SerialNumber} />
        )}
        {props.Volume !== undefined && <SectionData cols={colStyle} label={labels.volume} value={props.Volume} />}
      </div>
    </div>
  );
}
